import { Box, Flex, Text, VStack } from '@chakra-ui/react'
import { LuCheck } from 'react-icons/lu'

type StepKey = 1 | 2 | 3 | 4

export default function SignupProgressBar({ current }: { current: StepKey }) {
  const steps: { key: StepKey; label: string }[] = [
    { key: 1, label: 'Rechnung' },
    { key: 2, label: 'Konto erstellen' },
    { key: 3, label: 'Zusammenfassung' },
    { key: 4, label: 'Kaufbestätigung' },
  ]

  return (
    <VStack
      w="full"
      maxW="1304px"
      mx="auto"
      gap={{ base: 4, md: 8 }}
      align="center"
      textAlign="center"
    >
      {/* Step list */}
      <Flex w="full" justify="center" align="center" flexWrap="nowrap" gap={{ base: 2, md: 4 }}>
        {steps.map((step, i) => {
          const isDone = step.key < current
          const isCurrent = step.key === current

          return (
            <Flex key={step.key} align="center" gap={{ base: 2, md: 3 }}>
              {/* Circle indicator */}
              <Flex
                w={{ base: '36px', md: '44px' }}
                h={{ base: '36px', md: '44px' }}
                justify="center"
                align="center"
                borderRadius="full"
                borderWidth="2px"
                borderColor={isCurrent || isDone ? 'green.solid' : 'border'}
                bg={isDone ? 'green.solid' : isCurrent ? 'green.muted' : 'transparent'}
                color="fg.default"
              >
                {isDone ? <LuCheck color="white" size={18} /> : step.key}
              </Flex>

              {/* Label */}
              <Text
                fontSize={{ base: 'sm', md: 'md' }}
                fontWeight="600"
                color="fg.default"
                whiteSpace="nowrap"
                display={{ base: 'none', md: 'block' }}
              >
                {step.label}
              </Text>

              {/* Separator line */}
              {i < steps.length - 1 && (
                <Box
                  w={{ base: '36px', md: '115px' }}
                  h="0px"
                  borderTopWidth="2px"
                  borderColor="border"
                />
              )}
            </Flex>
          )
        })}
      </Flex>
    </VStack>
  )
}
